import { render, staticRenderFns } from "./ChangelogList.vue?vue&type=template&id=434d1ae7"
import script from "./ChangelogList.vue?vue&type=script&lang=js"
export * from "./ChangelogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports